import { Box, Container, Typography, Grid, Paper, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

type DemoVideo = {
  id: string;
  title: string;
  description: string;
  duration?: string;
  url?: string;
};

const demoVideos: DemoVideo[] = [
  {
    id: 'overview',
    title: 'Workflow Estate Overview',
    description: 'High-level walkthrough of how Workflow Estate helps agencies manage properties, open homes, and vendors.',
    duration: '4 min',
    url: 'https://www.loom.com/embed/46a8e2e263e643e38fa2c0fa76e59575',
  },
  {
    id: 'agency-branding',
    title: 'Agency Branding, Setting and Team Member Onboarding',
    description: 'Set up your agency profile, customize branding, configure settings, and onboard your team members.',
    duration: '5 min',
    url: 'https://www.youtube.com/embed/MulWPHEvDsI',
  },
  {
    id: 'workflows',
    title: 'Property Marketing Appraisal Workflow',
    description: 'See how to create a marketing appraisal using the standard Initial Consultation workflow.',
    duration: '7 min',
    url: 'https://www.youtube.com/embed/BtGQ1IyIOlg',
  },
  {
    id: 'agency-agreement-signing',
    title: 'Agency Agreement & Vendor Response',
    description: 'Create agency agreements and engage with vendor responses using the built-in document signing support.',
    duration: undefined,
    url: 'https://www.youtube.com/embed/a67SODZn5_s',
  },
];

const DemoVideos = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
      <Box sx={{ mb: 3 }}>
        <Button
          component={RouterLink}
          to="/"
          startIcon={<ArrowBack />}
          variant="outlined"
          size="small"
          sx={{ textTransform: 'none' }}
        >
          Back to main page
        </Button>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4, gap: 2, flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 1 }}>
            Product demo library
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Short videos that show how Workflow Estate works, from daily workflows to reporting.
          </Typography>
        </Box>
        <Button
          variant="outlined"
          onClick={() => navigate('/contact-sales')}
          sx={{ textTransform: 'none', borderRadius: '999px' }}
        >
          Talk to sales
        </Button>
      </Box>

      <Grid container spacing={3}>
        {demoVideos.map((video) => (
          <Grid item xs={12} md={6} key={video.id}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                borderRadius: 3,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {video.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {video.description}
              </Typography>
              {video.duration && (
                <Typography variant="caption" color="text.secondary">
                  Approx. {video.duration}
                </Typography>
              )}
              {video.url ? (
                <Box
                  sx={{
                    mt: 2,
                    position: 'relative',
                    width: '100%',
                    pb: '56.25%',
                    borderRadius: 2,
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(15,23,42,0.25)',
                  }}
                >
                  <iframe
                    src={video.url}
                    frameBorder="0"
                    allowFullScreen
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                    }}
                  />
                </Box>
              ) : (
                <Box
                  sx={{
                    mt: 2,
                    borderRadius: 2,
                    bgcolor: 'grey.100',
                    border: '1px dashed',
                    borderColor: 'grey.300',
                    p: 2,
                    textAlign: 'center',
                    color: 'text.secondary',
                    fontSize: '0.875rem',
                  }}
                >
                  Video player / link can go here.
                </Box>
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default DemoVideos;

